import { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";
import { api, eur } from "../lib/api";
import { useAuth } from "../context/AuthContext";

export default function PaymentResult() {
  const [params] = useSearchParams();
  const estado = params.get("estado");
  const orden = params.get("orden");
  const [order, setOrder] = useState(null);
  const { refresh } = useAuth();

  useEffect(() => {
    if (!orden) return;
    let attempts = 0;
    const poll = async () => {
      try {
        const { data } = await api.get(`/orders/${orden}`);
        setOrder(data);
        if (data.status === "paid") {
          refresh();
          return;
        }
      } catch {}
      attempts += 1;
      if (attempts < 8) setTimeout(poll, 2500);
    };
    poll();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [orden]);

  const confirmed = order?.status === "paid";
  const failed = estado === "ko" || order?.status === "failed";

  return (
    <div className="max-w-2xl mx-auto px-5 py-24 lg:py-32 text-center" data-testid="payment-result-page">
      {confirmed ? (
        <>
          <CheckCircle2 size={56} strokeWidth={1.25} className="text-gold mx-auto mb-6" />
          <h1 className="text-3xl lg:text-5xl text-white font-light" data-testid="payment-success-title">Pago confirmado</h1>
          <p className="mt-4 text-white/60 font-light">
            {order.kind === "membership"
              ? "Tu membresía de Cinegética Ruta del Agua está activa. Bienvenido a la hermandad."
              : "Tu pedido se ha registrado correctamente. Recibirás la confirmación por email."}
          </p>
          <p className="mt-3 text-sand text-sm" data-testid="payment-order-ref">Referencia: {orden} · {eur(order.total_cents / 100)}</p>
          <div className="mt-10 flex flex-col sm:flex-row gap-4 justify-center">
            <Link to={order.kind === "membership" ? "/area-socio" : "/tienda"} className="btn-gold-solid" data-testid="payment-continue-btn">
              {order.kind === "membership" ? "Ir a Mi Área" : "Volver a la Tienda"}
            </Link>
            <Link to="/" className="btn-ghost-light" data-testid="payment-home-btn">Inicio</Link>
          </div>
        </>
      ) : failed ? (
        <>
          <XCircle size={56} strokeWidth={1.25} className="text-red-400 mx-auto mb-6" />
          <h1 className="text-3xl lg:text-5xl text-white font-light" data-testid="payment-failed-title">Pago no completado</h1>
          <p className="mt-4 text-white/60 font-light">La operación fue cancelada o rechazada. No se ha realizado ningún cargo.</p>
          <div className="mt-10 flex flex-col sm:flex-row gap-4 justify-center">
            <Link to="/checkout" className="btn-gold-solid" data-testid="payment-retry-btn">Reintentar</Link>
            <Link to="/" className="btn-ghost-light">Inicio</Link>
          </div>
        </>
      ) : (
        <>
          <Loader2 size={48} strokeWidth={1.25} className="text-gold mx-auto mb-6 animate-spin" />
          <h1 className="text-3xl lg:text-4xl text-white font-light" data-testid="payment-pending-title">Confirmando tu pago...</h1>
          <p className="mt-4 text-white/60 font-light">Estamos verificando la operación con el TPV. Esto tarda unos segundos.</p>
        </>
      )}
    </div>
  );
}
